import { SystemIcon } from '../components/SystemIcon'
import { useNav } from '../nav'
import { haptic } from '../telegram'
import { useCharts } from './chartsData'
import './systems.css'

/**
 * «Расчёты» — список комнат: по одной карте в каждой. Раньше это была
 * отдельная вкладка; теперь вход только из «Я», потому что расчёт — это
 * местность, а не погода.
 */
export function Rooms() {
  const { data, error } = useCharts()
  const { navigate } = useNav()

  if (error) return <div className="state">{error}</div>
  if (!data) return <div className="state">Открываем карты…</div>

  return (
    <div className="screen systems">
      <div className="topbar">
        <div className="brand">АТЛАС</div>
        <div className="topnote">расчёты</div>
      </div>
      <h1 className="display">Четыре карты</h1>
      <div className="sub">У каждой свой язык: столпы, дворцы, печати, линии. Смотри по одной.</div>

      <div className="rowlist rooms">
        <button
          type="button"
          className="rowitem"
          onClick={() => {
            haptic('light')
            navigate({ screen: { kind: 'room', system: 'bazi' } })
          }}
        >
          <SystemIcon system="bazi" size={22} />
          <div>
            <div className="ttl">Четыре опоры</div>
            <div className="note">Ба Цзы · столпы и поток стихий</div>
          </div>
          <div className="right">›</div>
        </button>

        <button
          type="button"
          className={`rowitem${data.ziwei ? '' : ' sealed'}`}
          disabled={!data.ziwei}
          onClick={() => {
            haptic('light')
            navigate({ screen: { kind: 'room', system: 'ziwei' } })
          }}
        >
          <SystemIcon system="ziwei" size={22} />
          <div>
            <div className="ttl">Город двенадцати дворцов</div>
            <div className="note">{data.ziwei ? 'Цзы Вэй · звёзды по дворцам' : 'нужно точное время рождения'}</div>
          </div>
          <div className="right">{data.ziwei ? '›' : '🔒'}</div>
        </button>

        <button
          type="button"
          className="rowitem"
          onClick={() => {
            haptic('light')
            navigate({ screen: { kind: 'room', system: 'tzolkin' } })
          }}
        >
          <SystemIcon system="tzolkin" size={22} />
          <div>
            <div className="ttl">Печать времени</div>
            <div className="note">Цолькин · кин {data.tzolkin.kin}, {data.tzolkin.sealRu}</div>
          </div>
          <div className="right">›</div>
        </button>

        <div className="rowitem">
          <SystemIcon system="iching" size={22} />
          <div>
            <div className="ttl">Шесть линий</div>
            <div className="note">И-Цзин · открывается во вкладке «Оракул»</div>
          </div>
        </div>
      </div>

      <div className="lbl sect">Запечатано</div>
      <div className="rowlist">
        {[
          { title: 'Тибетский квадрат', note: 'Мева и Паркха — новая глава' },
          { title: 'Девять комнат времени', note: '9 звёзд Ки — новая глава' },
          { title: 'Песчаный щит', note: 'геомантия — новая глава' },
        ].map((item) => (
          <div className="rowitem sealed" key={item.title}>
            <div>
              <div className="ttl">{item.title}</div>
              <div className="note">{item.note}</div>
            </div>
            <div className="right">🔒</div>
          </div>
        ))}
      </div>
    </div>
  )
}
